import { yupResolver } from "@hookform/resolvers/yup";
import { useState } from "react";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { loginUser } from "store/slices/userSlice";
import { useAppDispatch, useAppSelector } from "store/store";
import { UserRoleTypes } from "utils/common";
import useDocumentTitle from "utils/useDocumentTitle";
import { object, string } from "yup";

export const useLogin = () => {
  useDocumentTitle("Login");

  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const [showPassword, setShowPassword] = useState(false);
  const [hasError, setHasError] = useState(false);

  const {
    authUser: { loading, error },
  } = useAppSelector((state) => state.user);

  const validationSchema = object({
    phone: string().required("Please enter phone number"),
    countryCode: string(),
    password: string().required("Please enter password"),
  });

  const form = useForm({
    defaultValues: {
      password: "",
      phone: "",
      countryCode: "+91",
    },
    resolver: yupResolver(validationSchema),
  });

  const onSubmit = async (values: any) => {
    if (hasError) {
      toast.error("Please enter valid phone number");
      return;
    }

    const resultAction = await dispatch(loginUser(values));
    if (loginUser.fulfilled.match(resultAction)) {
      const userData = resultAction.payload;

      if (userData.userRole === UserRoleTypes.trialUser) {
        navigate("/app/holdings", { replace: true });
      } else if (
        userData.isFirst ||
        !userData.profileDetails?.profileComplete
      ) {
        navigate("/app/company-onboarding", { replace: true });
      } else {
        navigate("/app/holdings");
      }
      window.location.reload();
    }
  };

  form.watch();

  return {
    isSubmitting: loading,
    navigate,
    form,
    onSubmit,
    showPassword,
    setShowPassword,
    hasError,
    setHasError,
    error,
  };
};
